import React from "react";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/analmeida4/weather_app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code
      </a>
      , by Ana Almeida
    </footer>
  );
}
